import ReducerGenerator from '../../lib/ReducerGenerator'

const generator = new ReducerGenerator('platform', '/platforms')
const reducer = generator.generate()

export default reducer
